export const COLOR_GRAY = '#484848';
export const DEFAULT_SPACING = '1rem';
export const DOUBLE_SPACING = '2rem';